import { Site } from "../models/Site.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * SiteViewModel fetches public site metadata for a slug and exposes it as
 * observable state. The View renders whatever the VM provides.
 */
export class SiteViewModel extends ViewModel {
    client;
    slug;
    constructor(client, slug) {
        super({ loading: false, error: null, site: null });
        this.client = client;
        this.slug = slug;
    }
    /**
     * Fail-closed SAMPLE wallpaper: show until load succeeds with sample=false.
     * Loading/error/unpaid all keep SAMPLE visible.
     */
    showsSample() {
        return this.state.site?.sample !== false;
    }
    /**
     * Fail-closed online ordering: false until load proves Connect KYC ready.
     */
    ordersEnabled() {
        return this.state.site?.ordersEnabled === true;
    }
    /** True when the API reports the kitchen edge is offline during open hours (#886). */
    kitchenOffline() {
        return this.state.site?.kitchenOffline === true;
    }
    async load() {
        await this.run(async () => {
            const dto = await this.client.getSite(this.slug);
            this.setState({ site: new Site(dto) });
        }, "Failed to load site.", { onError: () => ({ site: null }) });
    }
}
//# sourceMappingURL=SiteViewModel.js.map